import LegalLayout, { LegalSection } from "../components/LegalLayout";
import Seo from "../components/Seo";

export default function Cookies() {
  return (
    <LegalLayout
      eyebrow="Cookies & traceurs"
      title={<>Gestion des <span className="text-outline">cookies</span></>}
      updated="Juillet 2026"
      intro="Cette page explique comment ml-agence.fr utilise les cookies et traceurs, et comment vous en gardez le contrôle."
    >
      <Seo title="Gestion des cookies" description="Politique de gestion des cookies et traceurs du site ml-agence.fr." />
      <LegalSection title="Qu'est-ce qu'un cookie ?">
        <p>Un cookie est un petit fichier déposé sur votre appareil lors de la visite d'un site. Il permet, par exemple, de mémoriser vos préférences ou de mesurer l'audience. Certains cookies sont indispensables au fonctionnement du site, d'autres sont facultatifs et nécessitent votre accord.</p>
      </LegalSection>

      <LegalSection title="Cookies utilisés sur ce site">
        <ul className="space-y-3 list-none">
          <li>• <strong>Essentiels</strong> (toujours actifs) : mémorisation de votre choix de consentement aux cookies. Sans eux, le site ne peut pas retenir vos préférences. Ils ne nécessitent pas de consentement.</li>
          <li>• <strong>Mesure d'audience sans cookie</strong> : Vercel Web Analytics mesure la fréquentation de façon <strong>anonyme et sans cookie</strong> (aucune donnée personnelle, conforme RGPD). Il fonctionne sans consentement.</li>
          <li>• <strong>Statistiques d'usage (facultatifs)</strong> : si vous cliquez sur « Tout accepter », des outils comme Microsoft Clarity (cartes de chaleur) et/ou Google Analytics peuvent être activés pour mieux comprendre la navigation. Ils déposent des cookies et ne sont <strong>jamais activés sans votre consentement</strong>.</li>
        </ul>
      </LegalSection>

      <LegalSection title="Votre consentement">
        <p>Lors de votre première visite, un bandeau vous permet d'<strong>accepter</strong> ou de <strong>refuser</strong> les cookies facultatifs. Votre choix est mémorisé. Refuser n'a aucun impact sur votre navigation : le site reste pleinement fonctionnel.</p>
        <p>Vous pouvez à tout moment modifier votre choix en supprimant les cookies de votre navigateur, ou via ses réglages de confidentialité.</p>
      </LegalSection>

      <LegalSection title="Durée de conservation">
        <p>Les cookies de mesure et de préférence ont une durée de vie maximale de 13 mois, conformément aux recommandations de la CNIL, après quoi votre consentement vous est à nouveau demandé.</p>
      </LegalSection>
    </LegalLayout>
  );
}
